import enDictionary from './assets/dictionaries/en.json'
import itDictionary from './assets/dictionaries/it.json'
import esDictionary from './assets/dictionaries/es.json'
import frDictionary from './assets/dictionaries/fr.json'

import enCalendar from './assets/calendars/en.json'
import itCalendar from './assets/calendars/it.json'
import esCalendar from './assets/calendars/es.json'
import frCalendar from './assets/calendars/fr.json'

export class I18nHelper {
    static dictionaries = (): any => {
        return {
            'en-EN': enDictionary,
            'it-IT': itDictionary,
            'es-ES': esDictionary,
            'fr-FR': frDictionary,
        }
    }

    static calendars = (): any => {
        return {
            'en-EN': enCalendar,
            'it-IT': itCalendar,
            'es-ES': esCalendar,
            'fr-FR': frCalendar,
        }
    }

    static supportedLanguages = (): any => {
        return [
            { label: 'en-EN', value: 'en-EN' },
            { label: 'it-IT', value: 'it-IT' },
            { label: 'es-ES', value: 'es-ES' },
            { label: 'fr-FR', value: 'fr-FR' },
        ]
    }
}

export const i18nSupportedLanguages = I18nHelper.supportedLanguages()
export const i18nDictionaries: any = I18nHelper.dictionaries()
export const i18nCalendars: any = I18nHelper.calendars()

